<template>
<component :is="currentView" :obj-info="selectedNode" @change-page="$emit('change-page')"></component>
</template>

<script>
import { objType } from '@/constants/obj';
import WServerSlidingButtonGroup from './components/ServerSlidingButtonGroup';
import WNetdeviceSlidingButtonGroup from './components/NetdeviceSlidingButtonGroup';
import WNetinterfaceSlidingButtonGroup from './components/NetinterfaceSlidingButtonGroup';
import WDatabaseSlidingButtonGroup from './components/DatabaseSlidingButtonGroup';
import WEtcSlidingButtonGroup from './components/EtcSlidingButtonGroup';
import WServiceSlidingButtonGroup from './components/ServiceSlidingButtonGroup';
import WVirtualSlidingButtonGroup from './components/VirtualSlidingButtonGroup';
import WApSlidingButtonGroup from './components/ApSlidingButtonGroup';

export default {
  name: 'WPerfSlidingPopup',
  components: {
    WServerSlidingButtonGroup,
    WNetdeviceSlidingButtonGroup,
    WNetinterfaceSlidingButtonGroup,
    WDatabaseSlidingButtonGroup,
    WEtcSlidingButtonGroup,
    WServiceSlidingButtonGroup,
    WVirtualSlidingButtonGroup,
    WApSlidingButtonGroup,
  },
  props: {
    selectedNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentView: null,
    };
  },
  watch: {
    selectedNode: {
      handler(value) {
        if (value.obj) {
          this.loadComponent();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadComponent() {
      if (this.selectedNode.subType === objType.SERVER) {
        this.currentView = WServerSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.NETDEVICE) {
        this.currentView = WNetdeviceSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.NETINTERFACE) {
        this.currentView = WNetinterfaceSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.DBMS) {
        this.currentView = WDatabaseSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.SERVICE) {
        this.currentView = WServiceSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.VIRTUAL) {
        this.currentView = WVirtualSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.AP_CONTROLLER) {
        this.currentView = WNetdeviceSlidingButtonGroup.name;
      } else if (this.selectedNode.subType === objType.WIRELESS_AP) {
        this.currentView = WApSlidingButtonGroup.name;
      } else {
        this.currentView = WEtcSlidingButtonGroup.name;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/PerfSlidingPopupView.vue